import styled from 'styled-components';

import { Portal, Scroll } from '@dreryk/react-components';

export const StyledCalendarSidePanel = styled(Scroll)`
   gap: 20px;
`;

StyledCalendarSidePanel.displayName = 'CalendarSidePanel';

export const StyledCalendarSidePanelPortalContainer = styled(Portal.Container)`
   display: flex;
   flex-direction: column;
   gap: 12px;
`;

StyledCalendarSidePanelPortalContainer.displayName = 'StyledCalendarSidePanelPortalContainer';
